import React from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import styles from './NavigationColumn.module.css';
import NavigationButton from './NavigationButton';
import { ReactComponent as AppLogo } from '../../../../shared/project-info/svgs-web/AppLogo.svg';
import {
  logAccessFeed,
  logAccessEvents,
  logAccessMyProfile,
} from '../../../../shared/models/Analytics';
import ApiInfo from '../ApiInfo';
import {projectConfig} from '../../../../shared/project-info/projectConfig';
const pJSON = require('../../../package.json');

export default function NavigationColumn() {
  const location = useLocation();
  function isNavBarDisplayed(location) {
    const {pathname} = location;
    const allowedPaths = [
      '/feed',
      '/groups',
      '/events',
      '/challenges',
      '/profile',
      '/notifications',
      // '/login',
      // '/registration',
    ];
    for (const allowedPath of allowedPaths) {
      if (pathname.startsWith(allowedPath)) {
        return true;
      }
    }
    return false;
  }
  const showNavBar = isNavBarDisplayed(location);
  return (
    <div className={showNavBar ? styles.container : styles.none}>
      <div className={styles.navLinkContainer}>
        <div className={styles.navLogo}>
          <AppLogo className={styles.navLogo} />
        </div>
        {/* <NavLink to="/">
          <NavigationButton label={'Home'} url={'/'} />
        </NavLink> */}
        <NavLink onClick={logAccessFeed} to="/feed">
          <NavigationButton label={'Feed'} url={'/feed'} />
        </NavLink>
        {/* onClick={logAccessGroups} */}
      {projectConfig.hasGroups &&  <NavLink to="/groups">
          <NavigationButton label={'Groups'} url={'/groups'} />
        </NavLink>}
        <NavLink onClick={logAccessEvents} to="/events">
          <NavigationButton label={'Events'} url={'/events'} />
        </NavLink>
      {projectConfig.hasChallenges &&  <NavLink
          // onClick={logAccessChallenges}
          to="/challenges">
          <NavigationButton label={'Challenges'} url={'/challenges'} />
        </NavLink> }

        <NavLink onClick={logAccessMyProfile} to="/profile">
          <NavigationButton label={'Profile'} url={'/profile'} exact />
        </NavLink>
      </div>

      <div className={styles.settingsContainer}>
        <div>{projectConfig.orgName}</div>
        <div>
          <a
            className="link"
            href={projectConfig.privacyPolicy}
            target="_blank"
            rel="noreferrer noopener">
            Privacy Policy
          </a>
          </div>
          {projectConfig.userSupportLink && 
            <div>
              <a
                className="link"
                href={projectConfig.userSupportLink}
                target="_blank"
                rel="noreferrer noopener">
                Help Center
              </a>
            </div>
          }
        <div>
          <a
            className="link"
            href={projectConfig.communityGuidelines}
            target="_blank"
            rel="noreferrer noopener">
            Community Guidelines
          </a>
        </div>
        <div>
          <p style={{fontSize: 12}}>Version: {pJSON.version}</p>
        </div>
        <ApiInfo />
      </div>
    </div>
  );
}
